(function ($) {
    var cookieName = 'wep2-alerts';
    var cookieOptions = {
        path: window.location.href.replace(window.location.search, ''),
        expires: 365
    };
    var alertSelector = '.component.alert';

    function onAlertClose(evt) {
        var $alert = $(evt.target).closest('.alert'),
            isCookieAlert = $alert.find('[data-cookie-duration]');
        if (!isCookieAlert.length) return;
        evt.preventDefault();
        var duration = isCookieAlert.data('cookie-duration'),
            id = $alert.attr('id');
        closeAlert($alert);
        if (!isNaN(duration)) {
            handleCookieStorage(id, duration);
        }
    }

    function generateUniqueIds($alertList) {
        $alertList.each(function (i, alert) {
            var id = 'alert-component_' + $(alert).find('.alert-title').text().trim().replace(/\W/g, '');
            $(alert).attr('id', id);
        });
    }

    function handleCookieStorage(id, duration) {
        if (!window.Cookies) return;
        var cookieArray;
        try {
            cookieArray = JSON.parse(Cookies.get(cookieName));
        } catch (e) {
            cookieArray = [];
        }
        var alertExists = cookieArray.filter(function (alert) {
            return alert.id === id;
        }).length;
        if (!alertExists) {
            cookieArray.push({
                id: id,
                //					  days       hs   secs   ms
                expires: Date.now() + duration * 24 * 3600 * 1000
            });
            document.cookie = cookieName + "=" + JSON.stringify(cookieArray) + ";expires=" + cookieOptions.expires + ";path = /";
        }
    }

    function cleanAlertCookie() {
        var cookieArray = Cookies.get(cookieName);
        var hiddenAttr = 'data-hidden';
        var $alert;
        if (cookieArray?.length) {
            $.each(cookieArray, function (i, v) {
                if (v.expires <= Date.now()) {
                    cookieArray.splice(i, 1);
                } else {
                    $alert = $('#' + v.id);
                    if ($alert.length) {
                        $alert.attr(hiddenAttr, 'true');
                    }
                }
            });
            if (cookieArray.length)
                Cookies.set(cookieName, cookieArray, cookieOptions);
            else
                Cookies.remove(cookieName, cookieOptions);
        }
        $(alertSelector + '[' + hiddenAttr + ']').addClass('d-none');
    }

    function closeAlert($alert) {
        $alert.slideUp(250);
    }

    $(document).ready(function () {
        var unsupportedBrowserMessageDisplayed = window.sessionStorage.getItem("unsupportedBrowserMessageDisplayed");
        if (unsupportedBrowserMessageDisplayed === null) {
            $("body").on("click", ".unsupported-browser-close", function (evt) {
                window.sessionStorage.setItem("unsupportedBrowserMessageDisplayed", true);
                evt.preventDefault();
                $(".hide-for-older-versions").addClass("d-none");
            });
        }
        else {
            $(".hide-for-older-versions").addClass("d-none");
        }

        if (window.WEP.isPageEditor()) return false;
        if (window.Cookies) Cookies.json = true;
        var $alerts = $(alertSelector);
        if (!$alerts.length) return;
        generateUniqueIds($alerts);
    });

    $(window).on('load', function () {
        var $alerts = $(alertSelector);
        cleanAlertCookie();
        $(".alert:not(.cookie-consent-warning)").show();
        $alerts.on('click', '.field-alerttext~a', onAlertClose);
    });
}(window.jQuery));

// Analytics

analytics.eventConfig.push(
    {
        "target": ".component.a17-alert",
        "codeId": "a17",
        "events": [
            {
                "eventTarget": "a[href*=\\http]",
                "eventType": "click",
                "tags": {
                    "componentId": "a17",
                    "componentName": "alert",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "alert link",
                    "event": [
                        {
                            "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pds') !== -1 || $(context).attr('href').toLowerCase().search('psims') !== -1)",
                            "value": "download"
                        },
                        {
                            "rule": "true",
                            "value": "outbound"
                        }
                    ],
                    "eventType": [
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('pds') !== -1",
                            "value": "pds download click"
                        },
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('psims') !== -1",
                            "value": "sds download click"
                        },
                        {
                            "rule": "true",
                            "value": "outbound click"
                        }
                    ],
                    "fileName": "",
                    "titleText": ".alert .alert-title"
                }
            },
            {
                "eventTarget": "a:not([href*=\\http])",
                "eventType": "click",
                "tags": {
                    "componentId": "a17",
                    "componentName": "alert",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "alert link",
                    "event": [
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
                            "value": "contact"
                        },
                        {
                            "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                            "value": "download"
                        },
                        {
                            "rule": "true",
                            "value": "navigation"
                        }
                    ],
                    "eventType": [
                        {
                            "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
                            "value": "click to email"
                        },
                        {
                            "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pdf') !== -1 || $(context).attr('href').toLowerCase().search('xls') !== -1 || $(context).attr('href').toLowerCase().search('xlsx') !== -1 || $(context).attr('href').toLowerCase().search('doc') !== -1 || $(context).attr('href').toLowerCase().search('docx') !== -1)",
                            "value": "other media asset click"
                        },
                        {
                            "rule": "true",
                            "value": "alert internal navigation click"
                        }
                    ],
                    "fileName": "",
                    "titleText": ".alert .alert-title"
                }
            }
        ]
    },
)